import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IoIosCloseCircleOutline } from "react-icons/io";
import Background from "../../assets/background_2.png";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { isValidPhoneNumber } from "libphonenumber-js";

import {
  postAlumniRegistration,
  fetchIntakes,
} from "../../redux/slicer/aluminaiSlicer";
import {
  fetchDegreeData,
  fetchDegreeNames,
} from "../../redux/slicer/degreeSlice";

function AluminaiRegistration({ onClose }) {
  const dispatch = useDispatch();

  const [selectedOption, setSelectedOption] = useState("");
  const [selectedOption2, setSelectedOption2] = useState("agree");
  const [value, setValue] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    permanent_address: "",
    correspondence_address: "",
    mobile_no: "",
    resident_no: "",
    office_email: "",
    personal_email: "",
    nic_passport_no: "",
    designation: "",
    official_address: "",
    sab_academic_qualifications: "",
    year_of_enrollment: "",
    sab_reg_no: "",
    intake: "",
    year_of_degree_obtained: "",
  });

  const [degreeSpecialization, setDegreeSpecialization] = useState("general");
  const [selectedDegreeName, setSelectedDegreeName] = useState("");
  const [selectedDegreeId, setSelectedDegreeId] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [nicPassportError, setNicPassportError] = useState("");
  const [mobileNoError, setMobileNoError] = useState("");
  const [officeEmailError, setOfficeEmailError] = useState("");
  const [personalEmailError, setPersonalEmailError] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  // Helper function to normalize phone number (remove spaces and non-digit characters except +)
  const normalizePhoneNumber = (phone) => {
    if (!phone) return phone;
    // Keep only digits and the leading '+' for the country code
    return phone.replace(/[\s-]/g, "");
  };

  const handleInputChange = (e) => {
    const { name, value: inputValue } = e.target;

    setFormData({
      ...formData,
      [name]: inputValue,
    });

    // Immediately validate NIC/Passport on change
    if (name === "nic_passport_no") {
      validateNicPassport(inputValue);
    }

    // Validate email on change
    if (name === "office_email") {
      validateEmail(inputValue, "office");
    }
    if (name === "personal_email") {
      validateEmail(inputValue, "personal");
    }
  };

  const handlePhoneChange = (phoneValue) => {
    setValue(phoneValue);

    // Normalize the phone number
    const normalizedPhone = normalizePhoneNumber(phoneValue);

    // Update the form data with the normalized number
    setFormData((prevState) => ({
      ...prevState,
      mobile_no: normalizedPhone, // Store the normalized number
    }));

    validateMobileNumber(normalizedPhone);
  };

  const handleDegreeTypeChange = (e) => {
    const { value } = e.target;
    setSelectedDegreeName(value);
    const selectedDegree = degreeNameData.find(
      (degree) => degree.program_name === value
    );
    const degreeId = selectedDegree ? selectedDegree.id : null;
    setSelectedDegreeId(degreeId);

    // Update sab_academic_qualifications when degree name changes
    updateSabAcademicQualifications(value, degreeSpecialization);
  };

  const handleDegreeSpecializationChange = (event) => {
    const { value } = event.target;
    setDegreeSpecialization(value);

    // Update sab_academic_qualifications when degree specialization changes
    updateSabAcademicQualifications(selectedDegreeName, value);
  };

  const updateSabAcademicQualifications = (degreeName, specialization) => {
    if (degreeName) {
      const sabAcademicQualifications = `${degreeName} (${specialization})`;
      setFormData((prevState) => ({
        ...prevState,
        sab_academic_qualifications: sabAcademicQualifications,
      }));
    } else {
      setFormData((prevState) => ({
        ...prevState,
        sab_academic_qualifications: "", // Clear if no degree selected
      }));
    }
  };

  const { data: degreeNameData } = useSelector(
    (state) => state.degree.degreeName
  );
  const {
    data: intakes,
    loading: intakesLoading,
    error: intakesError,
  } = useSelector((state) => state.aluminai.intake);

  useEffect(() => {
    dispatch(fetchDegreeNames());
  }, [dispatch]);

  useEffect(() => {
    if (selectedDegreeId) {
      dispatch(fetchIntakes(selectedDegreeId));
    } else {
      dispatch(fetchIntakes());
    }
  }, [dispatch, selectedDegreeId]);

  const currentYear = new Date().getFullYear();
  const enrollYearOptions = Array.from(
    { length: currentYear - 2000 + 1 },
    (_, index) => 2000 + index
  );
  const obtainYearOptions = Array.from(
    { length: currentYear - 2000 + 1 },
    (_, index) => 2000 + index
  );

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
    setFormData({
      ...formData,
      academic_qualification: event.target.value,
    });
  };

  const handleOptionChange2 = (event) => {
    setSelectedOption2(event.target.value);
    setErrorMessage("");
  };

  const validateNicPassport = (nicPassport) => {
    setNicPassportError("");
    if (!nicPassport) {
      return true;
    }
    const nicRegexWithV = /^[0-9]{9}[Vv]$/;
    const nicRegexWithoutV = /^[0-9]{12}$/;
    if (nicRegexWithV.test(nicPassport)) {
      if (nicPassport.length !== 10) {
        setNicPassportError("Old NIC must be 10 characters long.");
        return false;
      }
      return true;
    } else if (nicRegexWithoutV.test(nicPassport)) {
      if (nicPassport.length !== 12) {
        setNicPassportError("New NIC must be 12 characters long.");
        return false;
      }
      return true;
    } else {
      setNicPassportError("Invalid NIC/Passport format.");
      return false;
    }
  };

  const validateMobileNumber = (normalizedPhone) => {
    setMobileNoError(""); // Clear previous error

    if (!normalizedPhone) {
      setMobileNoError("Mobile number is required.");
      return false;
    }

    if (normalizedPhone.startsWith("+94")) {
      if (!isValidPhoneNumber(normalizedPhone, "LK")) {
        setMobileNoError(
          "Please enter a valid Sri Lankan mobile number,without 0. (eg: 712346574)"
        );
        return false;
      }

      if (normalizedPhone.length !== 12) {
        setMobileNoError(
          "Sri Lankan mobile number including the country code +94 must be 12 digits."
        );
        return false;
      }
    }

    return true; // Valid mobile number
  };

  const validateEmail = (email, type) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email regex

    if (!email) {
      if (type === "office") {
        setOfficeEmailError("Office email is required.");
      } else {
        setPersonalEmailError("Personal email is required.");
      }
      return false;
    }

    if (!emailRegex.test(email)) {
      if (type === "office") {
        setOfficeEmailError("Invalid office email format.");
      } else {
        setPersonalEmailError("Invalid personal email format.");
      }
      return false;
    }

    if (type === "office") {
      setOfficeEmailError(""); // Clear error if valid
    } else {
      setPersonalEmailError(""); // Clear error if valid
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccessMessage("");
    setErrorMessage("");

    // Validate Degree Selection
    if (!selectedDegreeName) {
      setErrorMessage("Please select a Degree Program.");
      setShowPopup(true);
      return;
    }

    // Validate NIC/Passport
    if (nicPassportError) {
      return;
    }

    // Validate Mobile Number
    if (mobileNoError) {
      return;
    }

    // Validate Emails
    if (officeEmailError || personalEmailError) {
      return;
    }

    // Validate sab_academic_qualifications
    if (!formData.sab_academic_qualifications) {
      setErrorMessage(
        "Degree Program and Specialization should be properly specified"
      );
      setShowPopup(true);
      return;
    }

    try {
      const response = await dispatch(postAlumniRegistration(formData)); // Use formData directly

      if (response?.success) {
        setSuccessMessage(response.message);
        setErrorMessage("");
        setShowPopup(true);

        // Close the form after successful submission
        setTimeout(() => {
          onClose();
        }, 2000);

        // Reset form
        setFormData({
          name: "",
          permanent_address: "",
          correspondence_address: "",
          mobile_no: "",
          resident_no: "",
          office_email: "",
          personal_email: "",
          nic_passport_no: "",
          designation: "",
          official_address: "",
          sab_academic_qualifications: "",
          year_of_enrollment: "",
          sab_reg_no: "",
          intake: "",
          year_of_degree_obtained: "",
        });
        setValue("");
        setDegreeSpecialization("general");
        setSelectedDegreeName("");
        setSelectedDegreeId(null);
        setNicPassportError("");
        setMobileNoError("");
        setOfficeEmailError("");
        setPersonalEmailError("");
      } else {
        throw new Error(response?.message || "Something went wrong");
      }
    } catch (error) {
      setErrorMessage(error.message);
      setShowPopup(true);
    }
  };

  const handleResetForm = () => {
    setFormData({
      name: "",
      permanent_address: "",
      correspondence_address: "",
      mobile_no: "",
      resident_no: "",
      office_email: "",
      personal_email: "",
      nic_passport_no: "",
      designation: "",
      official_address: "",
      sab_academic_qualifications: "",
      year_of_enrollment: "",
      sab_reg_no: "",
      intake: "",
      year_of_degree_obtained: "",
    });
    setValue("");
    setSelectedOption("general");
    setSelectedOption2("agree");
    setSuccessMessage("");
    setErrorMessage("");
    setDegreeSpecialization("general");
    setSelectedDegreeName("");
    setSelectedDegreeId(null);
    setNicPassportError("");
    setMobileNoError("");
    setOfficeEmailError("");
    setPersonalEmailError("");
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  return (
    // JSX remains largely unchanged, with the key update in the PhoneInput component
    <div className="relative w-full mx-auto">
      <div className="w-full h-[200px] sm:h-[300px]">
        <img
          src={Background}
          alt="carousel-slide"
          className="w-full h-full object-cover object-center"
        />
      </div>
      <button
        type="button"
        onClick={onClose}
        className="absolute top-4 right-4 text-4xl text-gray-500 hover:text-black"
      >
        <IoIosCloseCircleOutline />
      </button>
      <div className="py-6 px-4 md:px-16 lg:px-28">
        <h2 className="text-2xl md:text-4xl text-primary-color text-center mb-6 font-titillium">
          Alumni Registration Form
        </h2>
        <form onSubmit={handleSubmit} className="mt-6 py-6 px-8 md:px-28">
          <div className="grid gap-y-6">
            <div>
              <label htmlFor="name" className="text-primary-color flex">
                Name (Mr./Mrs./Miss/Ms.)
              </label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                className="w-full p-2 border border-primary-color rounded mt-2"
                required
              />
            </div>
            <div>
              <label
                htmlFor="permanent_address"
                className="text-primary-color flex"
              >
                Permanent Address*
              </label>
              <input
                type="text"
                name="permanent_address"
                value={formData.permanent_address}
                onChange={handleInputChange}
                className="w-full p-2 border border-primary-color rounded mt-2"
                required
              />
            </div>
            <div>
              <label
                htmlFor="correspondence_address"
                className="text-primary-color flex"
              >
                Correspondence Address*
              </label>
              <input
                type="text"
                name="correspondence_address"
                value={formData.correspondence_address}
                onChange={handleInputChange}
                className="w-full h-[110px] p-2 border border-primary-color rounded mt-2"
              />
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label htmlFor="mobile_no" className="text-primary-color flex">
                Mobile Number
              </label>
              {/*  Key change: Use handlePhoneChange, pass raw value */}
              <PhoneInput
                country="lk"
                value={value}
                onChange={handlePhoneChange}
                className="w-full p-2 border border-primary-color rounded mt-2"
                required
              />
              {mobileNoError && (
                <p className="text-red-600 mt-1">{mobileNoError}</p>
              )}
            </div>
            <div>
              <label htmlFor="resident_no" className="text-primary-color flex">
                Resident Number
              </label>
              <input
                type="text"
                name="resident_no"
                value={formData.resident_no}
                onChange={handleInputChange}
                className="w-full p-2 border border-primary-color rounded mt-2"
              />
            </div>
            <div>
              <label htmlFor="office_email" className="text-primary-color flex">
                Personal Email
              </label>
              <input
                type="email"
                name="office_email"
                value={formData.office_email}
                onChange={handleInputChange}
                className="w-full p-2 border border-primary-color rounded mt-2"
                required
              />
              {officeEmailError && (
                <p className="text-red-600 mt-1">{officeEmailError}</p>
              )}
            </div>
            <div>
              <label
                htmlFor="personal_email"
                className="text-primary-color flex"
              >
                Office Email
              </label>
              <input
                type="email"
                name="personal_email"
                value={formData.personal_email}
                onChange={handleInputChange}
                className="w-full p-2 border border-primary-color rounded mt-2"
                required
              />
              {personalEmailError && (
                <p className="text-red-600 mt-1">{personalEmailError}</p>
              )}
            </div>
            <div>
              <label
                htmlFor="nic_passport_no"
                className="text-primary-color flex"
              >
                NIC/Passport Number
              </label>
              <input
                type="text"
                name="nic_passport_no"
                value={formData.nic_passport_no}
                onChange={handleInputChange}
                className="w-full p-2 border border-primary-color rounded mt-2"
                required
              />
              {nicPassportError && (
                <p className="text-red-600 mt-1">{nicPassportError}</p>
              )}
            </div>
            <div>
              <label htmlFor="designation" className="text-primary-color flex">
                Profession/Designation
              </label>
              <input
                type="text"
                name="designation"
                value={formData.designation}
                onChange={handleInputChange}
                className="w-full p-2 border border-primary-color rounded mt-2"
                required
              />
            </div>
          </div>
          <div className="mt-6">
            <label
              htmlFor="official_address"
              className="text-primary-color flex"
            >
              Company Name
            </label>
            <input
              type="text"
              name="official_address"
              value={formData.official_address}
              onChange={handleInputChange}
              className="w-full p-2 border border-primary-color rounded mt-2"
              required
            />
          </div>
          <div className="grid gap-y-6 mt-6 py-6">
            <label
              htmlFor="academic_qualification"
              className="text-primary-color flex"
            >
              Details of academic qualification obtained from the School of
              Accounting and Business:
            </label>
            <div className="py-6 px-10">
              <div>
                <h2 className="text-2xl text-primary-color mt-2 md:mt-0 w-full md:w-auto text-center md:text-left">
                  Select Degree
                </h2>
                <div className="w-full">
                  <select
                    name="degree_type"
                    onChange={handleDegreeTypeChange}
                    className="w-full p-2 border border-primary-color rounded mt-2"
                  >
                    <option value="">Select Degree Program</option>
                    {degreeNameData.map((degree) => (
                      <option key={degree.id} value={degree.program_name}>
                        {degree.program_name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="px-10">
              <label className="text-primary-color flex">
                Degree Specialization:
              </label>
              <div className="flex items-center space-x-8 mt-2">
                <label className="flex items-center space-x-2 cursor-pointer">
                  <input
                    type="radio"
                    value="general"
                    checked={degreeSpecialization === "general"}
                    onChange={handleDegreeSpecializationChange}
                    className="hidden"
                  />
                  <div
                    className={`w-5 h-5 border-2 rounded-full flex items-center justify-center ${
                      degreeSpecialization === "general"
                        ? "border-purple-600"
                        : "border-gray-400"
                    }`}
                  >
                    {degreeSpecialization === "general" && (
                      <div className="w-2 h-2 bg-primary-color rounded-full"></div>
                    )}
                  </div>
                  <span className="text-primary-color">General</span>
                </label>
                <label className="flex items-center space-x-2 cursor-pointer">
                  <input
                    type="radio"
                    value="special"
                    checked={degreeSpecialization === "special"}
                    onChange={handleDegreeSpecializationChange}
                    className="hidden"
                  />
                  <div
                    className={`w-5 h-5 border-2 rounded-full flex items-center justify-center ${
                      degreeSpecialization === "special"
                        ? "border-purple-600"
                        : "border-gray-400"
                    }`}
                  >
                    {degreeSpecialization === "special" && (
                      <div className="w-2 h-2 bg-primary-color rounded-full"></div>
                    )}
                  </div>
                  <span className="text-primary-color">Special</span>
                </label>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label
                  htmlFor="year_of_enrollment"
                  className="text-primary-color flex"
                >
                  Year of Enrolment
                </label>
                <select
                  name="year_of_enrollment"
                  value={formData.year_of_enrollment}
                  onChange={handleInputChange}
                  className="w-full p-2 border border-primary-color rounded mt-2"
                  required
                >
                  <option value="">Select Enrolled Year</option>
                  {enrollYearOptions.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label htmlFor="sab_reg_no" className="text-primary-color flex">
                  SAB Registration Number
                </label>
                <input
                  type="text"
                  name="sab_reg_no"
                  value={formData.sab_reg_no}
                  onChange={handleInputChange}
                  className="w-full p-2 border border-primary-color rounded mt-2"
                  required
                />
              </div>
              <div>
                <label htmlFor="intake" className="text-primary-color flex">
                  Intake
                </label>
                {intakesLoading && <p>Loading Intakes...</p>}
                {intakesError && <p>Error: {intakesError}</p>}
                <select
                  name="intake"
                  value={formData.intake}
                  onChange={handleInputChange}
                  className="w-full p-2 border border-primary-color rounded mt-2"
                >
                  <option value="">Select Intake</option>
                  {intakes.map((intake) => (
                    <option key={intake.id} value={intake.alumni_intake}>
                      {intake.alumni_intake}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label
                  htmlFor="year_of_degree_obtained"
                  className="text-primary-color flex"
                >
                  Year of obtaining Degree
                </label>
                <select
                  name="year_of_degree_obtained"
                  value={formData.year_of_degree_obtained}
                  onChange={handleInputChange}
                  className="w-full p-2 border border-primary-color rounded mt-2"
                  required
                >
                  <option value="">Select Obtain Year</option>
                  {obtainYearOptions.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <label
              htmlFor=""
              className="text-primary-color flex font-bold mt-5"
            >
              Declaration by the applicant:
            </label>
            <label htmlFor="" className="text-primary-color flex text-left">
              I certify that the above particulars are true and correct and I
              agree to inform any changes about my permanent address and contact
              details immediately to the Secretary of the Alumni Association of
              School of Accounting and Business, CA Sri Lanka.
            </label>
            <div className="flex items-center space-x-8">
              <label className="flex items-center space-x-2 cursor-pointer">
                <input
                  type="radio"
                  value="agree"
                  checked={selectedOption2 === "agree"}
                  onChange={handleOptionChange2}
                  className="hidden"
                />
                <div
                  className={`w-5 h-5 border-2 rounded-full flex items-center justify-center ${
                    selectedOption2 === "agree"
                      ? "border-purple-600"
                      : "border-gray-400"
                  }`}
                >
                  {selectedOption2 === "agree" && (
                    <div className="w-2 h-2 bg-primary-color rounded-full"></div>
                  )}
                </div>
                <span className="text-primary-color"> Agree</span>
              </label>
              <label className="flex items-center space-x-2 cursor-pointer">
                <input
                  type="radio"
                  value="disagree"
                  checked={selectedOption2 === "disagree"}
                  onChange={handleOptionChange2}
                  className="hidden"
                />
                <div
                  className={`w-5 h-5 border-2 rounded-full flex items-center justify-center ${
                    selectedOption2 === "disagree"
                      ? "border-purple-600"
                      : "border-gray-400"
                  }`}
                >
                  {selectedOption2 === "disagree" && (
                    <div className="w-2 h-2 bg-primary-color rounded-full"></div>
                  )}
                </div>
                <span className="text-primary-color">Disagree</span>
              </label>
            </div>
            <button
              type="button"
              onClick={handleResetForm}
              className="bg-gray-500 text-white p-2 rounded"
            >
              Reset Form
            </button>
            {errorMessage && (
              <p className="text-red-600 mt-2">{errorMessage}</p>
            )}
            <button
              type="submit"
              className="mt-6 bg-primary-color text-white p-2 rounded"
            >
              Submit Registration
            </button>
          </div>
          {showPopup && (
            <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
              <div className="bg-white p-6 rounded-lg max-w-md w-full shadow-lg relative">
                <button
                  type="button"
                  onClick={closePopup}
                  className="absolute top-4 right-4 text-gray-500 hover:text-black text-2xl"
                >
                  ×
                </button>
                <h3 className="text-xl font-bold text-primary-color mb-4">
                  Information
                </h3>
                <p className="text-black">
                  {successMessage
                    ? successMessage
                    : errorMessage
                    ? errorMessage
                    : "Something went wrong."}
                </p>
                <div className="mt-6 flex justify-end">
                  <button
                    onClick={closePopup}
                    className="bg-primary-color text-white px-4 py-2 rounded"
                  >
                    Okay
                  </button>
                </div>
              </div>
            </div>
          )}
        </form>
      </div>
    </div>
  );
}

export default AluminaiRegistration;